import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ButtonBack } from "../Button/Back";
import {getMessagemErro} from "../../utils/erro";
import api from "../../services/api";
import './Contract.css';
import DatePicker , { registerLocale } from "react-datepicker";
import pt_br from "date-fns/locale/pt-BR";
import "react-datepicker/dist/react-datepicker.css";
import { ContractDetails } from "./ContractDetails";

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
	}
}
registerLocale("pt_br", pt_br);

export const BillingReferenceEdit =

withRouter(

// redux
connect(
	(mapStateToProps),
	(mapDispatchToProps)
)(
	class extends Component {

		constructor(props){
			super(props);
			const idContrato = this.props.match.params.idContrato;
			this.referenciaInicial = {
				id: undefined,
				idContrato,
				referencia: "",
				referenciaFinal: "",
				periodoInicial: "",
				periodoFinal: "",
				preenchePeriodoReferencia: true,
			}
			this.initialState = {
				contrato: {},
				referenciaFaturamento: {...this.referenciaInicial},
				resultadoPesquisa: {},
				pesquisaExecutada: false,
				exibeModalAtivar: false,
				exibeModalInativar: false,
				exibeModalConfirmacao: false,
				botoesHabilitados : true,
			};

			this.state = this.initialState;
			this.handleInputChange = this.handleInputChange.bind(this);
			this.handlePreenchePeriodoReferenciaChange = this.handlePreenchePeriodoReferenciaChange.bind(this);
			this.salvar = this.salvar.bind(this);
			this.novo = this.novo.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
						<Message />
						<Loading />
						
						<div  style={{margin: "10px"}}>
							<h1>Cadastro de Contrato - Referências de faturamento</h1>
						</div>

					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			const idContrato = this.props.match.params.idContrato;
			const id = this.props.match.params.id;
			if(id){
				api.get(`/api/referencia-faturamento/${id}`)
					.then(response => { 
						const referenciaFaturamento = response.data;
						this.setState(prevState => ({ ...prevState, referenciaFaturamento }))
					})
					.catch(erro => {
						console.log("Não foi possível recuperar a referência de faturamento " + erro)
						this.props.exibeMensagemErro("Erro durante o carregamento da página")
					});
			}

			if(idContrato){
				api.get(`/api/contrato/${idContrato}`)
					.then(response => { 
						const contrato = response.data;
						this.setState(prevState => ({ ...prevState, contrato,}))
					})
					.catch(erro => {
						console.log("Não foi possível recuperar o contrato " + erro)
						this.props.exibeMensagemErro("Erro durante o carregamento da página")
					});
			}
		}	

		renderForm() {
			const {contrato, referenciaFaturamento} = this.state;
			const edicao = referenciaFaturamento.id ? true : false;

			return(
				<div className="container-fluid">
					<div className="br-form">

						<ContractDetails contrato={contrato} />

						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="referencia">Mês de Referência Inicial:</label>
										<DatePicker id="referencia" locale="pt_br" dateFormat="MM/yyyy" 
											showMonthYearPicker 
											selected={referenciaFaturamento.referencia} 
											onChange={data => {
												const referenciaFaturamento = this.state.referenciaFaturamento;
												referenciaFaturamento['referencia'] = data;
												this.setState(prevState => ({ ...prevState, referenciaFaturamento}))}
											} />
									</div>
								</div>
							</div>

							{(!edicao && referenciaFaturamento.preenchePeriodoReferencia) &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label htmlFor="referencia">Mês de Referência Final:</label>
											<DatePicker id="referencia" locale="pt_br" dateFormat="MM/yyyy" 
												showMonthYearPicker 
												selected={referenciaFaturamento.referenciaFinal} 
												onChange={data => {
													const referenciaFaturamento = this.state.referenciaFaturamento;
													referenciaFaturamento['referenciaFinal'] = data;
													this.setState(prevState => ({ ...prevState, referenciaFaturamento}))}
												} />
										</div>
									</div>
								</div>
							}

							{(edicao || referenciaFaturamento.preenchePeriodoReferencia === false) &&
								<>
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label htmlFor="periodoInicial">Período inicial:</label>
												<DatePicker id="periodoInicial" locale="pt_br" dateFormat="dd/MM/yyyy" 
													selected={referenciaFaturamento.periodoInicial} 
													onChange={data => {
														const referenciaFaturamento = this.state.referenciaFaturamento;
														referenciaFaturamento['periodoInicial'] = data;
														this.setState(prevState => ({ ...prevState, referenciaFaturamento}))}
													} />
											</div>
										</div>
									</div>
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label htmlFor="periodoFinal">Período Final:</label>
												<DatePicker id="periodoFinal" locale="pt_br" dateFormat="dd/MM/yyyy" 
													selected={referenciaFaturamento.periodoFinal} 
													onChange={data => {
														const referenciaFaturamento = this.state.referenciaFaturamento;
														referenciaFaturamento['periodoFinal'] = data;
														this.setState(prevState => ({ ...prevState, referenciaFaturamento}))}
													} />
											</div>
										</div>
									</div>
								</>
							}
						</div>

						{!edicao &&
							<div className="row">
								<div className="col-md">
									<div className="check">
										<div className="input">
											<input type="checkbox" name="preenchePeriodoReferencia" checked={referenciaFaturamento.preenchePeriodoReferencia} onChange={this.handlePreenchePeriodoReferenciaChange} />
											<label>Preencher com o primeiro e o último dia do mês de cada referência</label>
										</div>
									</div>
								</div>
							</div>
						}

						{/* button actions */}
						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={this.salvar} disabled={!this.state.botoesHabilitados}>{this.state.referenciaFaturamento.id ? 'Alterar' : 'Incluir'}</button>

								{this.state.referenciaFaturamento.id && 
									<button type="button" className="button is-secondary botaoNovo" onClick={this.novo} disabled={!this.state.botoesHabilitados}>Nova Referência de Faturamento</button>
								}

								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>

					</div>
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const referenciaFaturamento = this.state.referenciaFaturamento;
			referenciaFaturamento[nome] = valor;
			this.setState(prevState => ({ ...prevState, referenciaFaturamento }));
		}

		handlePreenchePeriodoReferenciaChange(evento){
			const target = evento.target;
			const preenchePeriodoReferencia = target.checked;

			const referenciaFaturamento = this.state.referenciaFaturamento;
			referenciaFaturamento['preenchePeriodoReferencia'] = preenchePeriodoReferencia;
			referenciaFaturamento['referenciaFinal'] = '';
			referenciaFaturamento['periodoInicial'] = '';
			referenciaFaturamento['periodoFinal'] = '';
			this.setState(prevState => ({ ...prevState, referenciaFaturamento }));
		}

		novo(e){
			const idContrato = this.props.match.params.idContrato;
			const rotaParaNovo = `/billing-reference/${idContrato}/new`;
			if (rotaParaNovo === this.props.location.pathname) {
				// reseta state se estiver na tela de cadastrar novo 
				this.setState(prevState => ({ ...prevState, 
					referenciaFaturamento: {
						...this.referenciaInicial
					},
				}));
			} else {
				// redireciona para tela de cadastro caso esteja na tela de edição
				this.props.history.push(rotaParaNovo);
			}
		}

		salvar(e){
			this.props.limpaMensagem();

			try{
				this.validaFormulario();
			}catch(erroValidacao){
				e.preventDefault();
				return;
			}

			this.setState(prevState => ({ ...prevState, botoesHabilitados:false}));
			const referenciaFaturamento = this.state.referenciaFaturamento;
			const method = referenciaFaturamento.id ? 'put' : 'post';
			let url = "/api/referencia-faturamento";
			if(referenciaFaturamento.id){
				url = url + '/' + referenciaFaturamento.id;
			}
			const options = {
				method,
				url,
				"data" : referenciaFaturamento,
			}

			api(options)
				.then(response => {
					let referenciaFaturamento = response.data;
					let mensagem = 'Referência de Faturamento alterada com sucesso' 
					
					if(!this.state.referenciaFaturamento.id) {
						referenciaFaturamento = this.referenciaInicial;
						mensagem = 'Referência(s) de faturamento incluída(s) com sucesso!';
					}

					this.setState(prevState => ({ ...prevState, referenciaFaturamento}));
					this.props.exibeMensagemSucesso(mensagem);
				})
				.catch(erro => {
					const mensagemInicial = `Não foi possível ${this.state.referenciaFaturamento.id ? 'alterar' : 'incluir'} a referência de faturamento.`;
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.setState(prevState => ({ ...prevState, botoesHabilitados:true}));
				});   

		}

		validaFormulario(){
			let mensagens = [];
			const contrato = this.state.referenciaFaturamento.idContrato;
			if(!contrato){
				mensagens.push({mensagem: "Contrato é obrigatório."})
			}

			let referencia = this.state.referenciaFaturamento.referencia;
			if(!referencia){
				mensagens.push({mensagem: "Referência é obrigatória."})
			}

			const preenchePeriodoReferencia = this.state.referenciaFaturamento.preenchePeriodoReferencia;
			if(preenchePeriodoReferencia === true){
				let referenciaFinal = this.state.referenciaFaturamento.referenciaFinal;

				if(referencia && referenciaFinal){
					referencia = new Date(referencia);
					referenciaFinal = new Date(referenciaFinal);

					if(referencia > referenciaFinal){
						mensagens.push({mensagem: "A referência inicial deve ser menor ou igual à referência final."})
					} 
				}
			} else {

				let periodoInicial = this.state.referenciaFaturamento.periodoInicial;
				if(!periodoInicial){
					mensagens.push({mensagem: "Período Inicial é obrigatório."})
				}

				let periodoFinal = this.state.referenciaFaturamento.periodoFinal;
				if(!periodoFinal){
					mensagens.push({mensagem: "Período Final é obrigatório."})
				}

				if(periodoInicial && periodoFinal){
					periodoInicial = new Date(periodoInicial);
					periodoFinal = new Date(periodoFinal);

					if(periodoInicial > periodoFinal){
						mensagens.push({mensagem: "O Período Inicial deve ser menor ou igual ao Período Final."})
					} else {
						var diff = Math.floor(periodoFinal.getTime() - periodoInicial.getTime());
						var day = 1000 * 60 * 60 * 24;
						
						if((diff/day) > 30){
							mensagens.push({mensagem: "O Período deve ser menor ou igual a 31 dias."})
						}

						if(periodoInicial.getYear() !== periodoFinal.getYear()){
							mensagens.push({mensagem: "O Período Inicial e o Período Final devem estar no mesmo ano."})
						}
					}
				}
			}

			if(mensagens.length > 0){
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", mensagens)
				throw new Error("Formulário não preenchido corretamente.");
			}
		}

	}

) // redux
); // router